// test322
(322 && 0);
